import { useState } from 'react';
import { FormattedMessage } from 'react-intl';

import { Input } from 'ui-components/components/input';
import { Text, TextType } from 'ui-components/components/text';

import { messages } from './messages';
import styles from './styles.module.less';
import { useImportContext } from '../../import-context';
import { MappingTable } from '../../mapping-table/mapping-table';
import { RemainingCsvColumns } from '../../remaining-csv-columns/remaining-csv-columns';
import { StepHeader } from '../../step-header/step-header';
import { StepInfo } from '../../step-info/step-info';
import { StepSuspense } from '../../step-suspense/step-suspense';

/**
 * Basic component for generating body for create mapping step.
 * Don't add functions to it here unless every type of import will support it.
 * Instead, create your own component and assign it to the renderBody in your step.
 * @returns {React.JSX.Element}
 */
export const CreateMappingStepBody = () => {
  const { isImportLoading, mappingName, setMappingName, isMappingNameUnique, isInitImportLoading, initRequest } = useImportContext();

  const [isError, setIsError] = useState(false);

  const mappingIsSelected = initRequest.mapping.mappingId !== undefined;

  /**
   * @param {string} name
   */
  const onChange = (name) => {
    const isValid = isMappingNameUnique(name);
    setIsError(!isValid);
    setMappingName(name);
  };

  return (
    <StepSuspense isLoading={isInitImportLoading || isImportLoading}>
      <StepHeader>
        <FormattedMessage {...messages.matchColumns} />
      </StepHeader>
      <StepInfo>
        <FormattedMessage {...messages.matchingInfo1} />
      </StepInfo>
      <Text
        className={styles['template-name-label']}
        formattedMessageValues={{
          optionalMessage: (chunks) => !mappingIsSelected && <span className={styles['input-additional-info']}>{chunks}</span>,
        }}
        htmlFor='mapping-template-input'
        textType={TextType.Label}
        value={messages.mappingNameTitle}
      />
      <div className={styles['input-container']}>
        <Input disabled={mappingIsSelected} name='mapping-template' onChange={onChange} value={mappingName} />
        {isError ? <Text className={styles.error} textType={TextType.Caption} value={messages.mappingNameRepeatedMessage} /> : null}
      </div>
      <RemainingCsvColumns />
      <MappingTable />
    </StepSuspense>
  );
};
